import {createReducer} from "./index";
import * as R from 'ramda';
import {ADD_PROJECT_CONTACTS, DELETE_PROJECT_CONTACT} from "../actions/projectcontacts";

/*
 Structure of projectcontacts model

{
  data: {
    [projectid]: {
      [contactuserid]: {
        projectid: string // uuid
        contactuserid: stirng // uuid
        active: bool
        role: string
        submittaladmin: bool
        taskadmin: bool
        punchlistitemadmin: bool
        projectrfiadmin: bool
        dailylogadmin: bool
        datecreated: datetime
      }
    }
  }
  indexes: {
  }
}

 */

const initial = {
  data: {},
  indexes: {}
};

export const projectContactsReducer = createReducer(initial,
  {
    [ADD_PROJECT_CONTACTS]: (state, action) => {
      let newState = state;
      action.payload.forEach(contact => {
        newState = R.over(R.lensPath(['data', contact.projectid, contact.contactuserid]), () => contact)(newState);
      });
      return newState;
    },
    [DELETE_PROJECT_CONTACT]: (state, action) => {
      const { projectId, userId } = action.payload;
      return R.dissocPath(['data', projectId, userId], state);
    }
    // 'ACTION_NAME': function (state, action) -> new_state
  });



// WEBPACK FOOTER //
// ./src/reducers/projectcontacts.js